import { Component } from '@angular/core';
import {HeaderComponent} from "../../header/header.component";
import {FooterComponent} from "../../footer/footer.component";
import {Router} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'vex-refund-policy',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './refund-policy.component.html',
  styleUrl: './refund-policy.component.scss'
})
export class RefundPolicyComponent {
  constructor(private router: Router,
              private meta : Meta,
              private title : Title) {
  }
  ngOnInit() {
    this.updateMetaTags()
  }
  goTo(url) {
    this.router.navigateByUrl(url);
  }
  updateMetaTags() {
    this.title.setTitle('Access Your Admission Management Account, Login to Enroll');
    this.meta.updateTag({name: 'description', content: `Login to Enroll and manage your admissions processes with ease. Access your account to streamline student enrollment and enhance your institution's workflow.`});
  }
}
